module.exports = __webpack_public_path__ + "static/media/cancel.2e9b26de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cancel.svg
// module id = 358
// module chunks = 0